import { useState, useRef } from 'react';
import {
  JFormik,
  Loading,
  selectUser,
  useChangePwMutation,
} from '@centerpiece/components';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import {
  useGetContactQuery,
  usePatchContactMutation,
  useUpdateContactMutation,
  useGetTeamsQuery,
  useUpdateSubscriberMutation,
  useGetSubscriberQuery,
} from 'store/api';
import {
  Grid,
  Typography,
  Tooltip,
  IconButton,
  Button,
  CircularProgress,
} from '@mui/material';
import { Save, Edit, RestartAlt } from '@mui/icons-material';
import { useContactForm } from 'jformik/useContactForm';
import { Contact, Subscriber, Team } from 'store/api/models';

export const MyAccountTab = () => {
  const user = useSelector(selectUser);
  const [isEditing, setEditing] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const formRef = useRef<any>();
  // const { data: contact, isLoading } = useGetContactQuery(
  //   { id: user.contact },
  //   { skip: !user.contact }
  // );
  const { data: subscriber = {} as Subscriber, isLoading } =
    useGetSubscriberQuery(
      { id: user.subscriber, params: { nested: 'all' } },
      { skip: !user.subscriber }
    );
  const { contact_r: contact, role_r } = subscriber;
  const { data: teams = [], isLoading: teamsLoading } = useGetTeamsQuery({});
  const [patchContact, patchResult] = usePatchContactMutation();
  const [updateSubscriber, updateSubscriberResult] =
    useUpdateSubscriberMutation();
  const [changepw] = useChangePwMutation();
  const [updateContact, updateContactResult] = useUpdateContactMutation();
  const contactForm = useContactForm({
    edit: true,
    minimal: !isEditing,
    externalSubmit: true,
    role: true,
    account: true,
  });
  if (!contact || isLoading || teamsLoading) {
    return <Loading />;
  } else {
    return (
      <Grid container spacing={2} item xs={12}>
        <Grid item xs={12}>
          <Typography variant="h6" align="center">
            Account Information
            <Tooltip title={isEditing ? 'Save' : 'Edit'}>
              <IconButton
                color="primary"
                onClick={async () => {
                  if (isEditing) {
                    setEditing(false);
                    if (formRef.current) {
                      formRef.current.submitForm();
                    }
                  } else {
                    setEditing(true);
                  }
                }}
                sx={{ ml: 1 }}
              >
                {updateSubscriberResult.isLoading || loading ? (
                  <CircularProgress sx={{ fontSize: '0.5rem' }} />
                ) : isEditing ? (
                  <Save fontSize="small" />
                ) : (
                  <Edit fontSize="small" />
                )}
              </IconButton>
            </Tooltip>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" align="center" color="textSecondary">
            To edit you account info click the edit icon above, make your
            changes then click the save icon.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <JFormik
            disabled={!isEditing}
            formRef={formRef}
            loading={isLoading}
            enableReinitialize={true}
            initialValues={() => ({
              ...contact,
              id: user.subscriber,
              name: `${contact.firstname} ${contact.lastname}`,
              role: role_r,
              form: {
                ...contact.form,
                team: teams.find((t: Team) => t.id == contact?.form?.team?.id),
              },
            })}
            handleSubmit={async (values, formik) => {
              try {
                setEditing(false);
                setLoading(true);
                const res = await updateSubscriber({
                  ...values,
                  role: values?.role?.id,
                  id: user.subscriber,
                });
                if ('error' in res) {
                  toast.error(
                    'Unable to update account info, please try again'
                  );
                } else {
                  toast.success('Account info update successful');
                }
                setLoading(false);
              } catch (error) {
                toast.error('Unable to update account info, please try again');
                setLoading(false);
              }
            }}
            validationSchema={contactForm.validationSchema}
            form={contactForm.form}
            // validationSchema={Yup.object({
            //   firstname: Yup.string().required('First Name is required'),
            //   lastname: Yup.string().required('Last Name is required'),
            //   email: Yup.string()
            //     .required('Email is required')
            //     .email('Invalid email address')
            // })}
            // form={[
            //   {
            //     name: 'firstname',
            //     label: "First Name *",
            //     itemType: 'textfield',
            //     jItemProps: { width: '30%' },
            //     gridProps: { xs: 12 },
            //   },
            //   {
            //     name: 'lastname',
            //     label: "Last Name *",
            //     itemType: 'textfield',
            //     jItemProps: { width: '30%' },
            //     gridProps: { xs: 12 },
            //   },
            //   {
            //     name: 'email',
            //     label: "Email *",
            //     itemType: 'textfield',
            //     jItemProps: { width: '40%' },
            //     gridProps: { xs: 12 },
            //   },
            // ]
            // }
          />
        </Grid>
        {/* <Grid item xs={12} sx={{ mt: 3 }}>
          <JFormik
            initialValues={(resource: any) => ({ ...contact })}
            validationSchema={Yup.object()}
            handleSubmit={() => {}}
            form={[
              {
                name: 'h6',
                itemType: 'typography',
                label: 'Account Notifications',
                jItemProps: { variant: 'h6', align: 'center' },
              },
              {
                name: 'form.notification.weekly_items_at_risk',
                itemType: 'checkbox',
                label: (
                  <span>
                    Weekly <u>My Items at Risk</u> email notification.
                  </span>
                ),
                jItemProps: {
                  // loading: patchResult.isLoading,
                  onChange: async (values: any) => {
                    try {
                      values.setFieldValue(
                        'form.notification.weekly_items_at_risk',
                        values.checked
                      );
                      await patchContact({
                        id: contact.id,
                        form: {
                          notification: {
                            weekly_items_at_risk: values.checked,
                          },
                        },
                      } as Contact);
                    } catch (error) {
                      values.setFieldValue(
                        'form.notification.weekly_items_at_risk',
                        !values.checked
                      );
                      toast.error(
                        'Error updating notifications, please try again'
                      );
                    }
                  },
                },
              },
              {
                precondition: () =>
                  contact?.form?.authorization === 'Team Leader',
                name: 'form.notification.weekly_team_items_at_risk',
                itemType: 'checkbox',
                label: (
                  <span>
                    Weekly <u>Team Items at Risk</u> email notification.
                  </span>
                ),
                jItemProps: {
                  // loading: patchResult.isLoading,
                  onChange: async (values: any) => {
                    try {
                      values.setFieldValue(
                        'form.notification.weekly_team_items_at_risk',
                        values.checked
                      );
                      await patchContact({
                        id: contact.id,
                        form: {
                          notification: {
                            weekly_team_items_at_risk: values.checked,
                          },
                        },
                      } as Contact);
                    } catch (error) {
                      values.setFieldValue(
                        'form.notification.weekly_team_items_at_risk',
                        !values.checked
                      );
                      toast.error(
                        'Error updating notifications, please try again'
                      );
                    }
                  },
                },
              },
              {
                precondition: () =>
                  contact?.form?.authorization === 'Team Leader',
                name: 'form.notification.weekly_team_stages_at_risk',
                itemType: 'checkbox',
                label: (
                  <span>
                    Weekly <u>Team Stages at Risk</u> email notification.
                  </span>
                ),
                jItemProps: {
                  // loading: patchResult.isLoading,
                  onChange: async (values: any) => {
                    try {
                      values.setFieldValue(
                        'form.notification.weekly_team_stages_at_risk',
                        values.checked
                      );
                      await patchContact({
                        id: contact.id,
                        form: {
                          notification: {
                            weekly_team_stages_at_risk: values.checked,
                          },
                        },
                      } as Contact);
                    } catch (error) {
                      values.setFieldValue(
                        'form.notification.weekly_team_stages_at_risk',
                        !values.checked
                      );
                      toast.error(
                        'Error updating notifications, please try again'
                      );
                    }
                  },
                },
              },
              {
                precondition: () =>
                  contact?.form?.authorization === 'Executive',
                name: 'form.notification.weekly_all_items_at_risk',
                itemType: 'checkbox',
                label: (
                  <span>
                    Weekly <u>All Items at Risk</u> email notification.
                  </span>
                ),
                jItemProps: {
                  // loading: patchResult.isLoading,
                  onChange: async (values: any) => {
                    try {
                      values.setFieldValue(
                        'form.notification.weekly_all_items_at_risk',
                        values.checked
                      );
                      await patchContact({
                        id: contact.id,
                        form: {
                          notification: {
                            weekly_all_items_at_risk: values.checked,
                          },
                        },
                      } as Contact);
                    } catch (error) {
                      values.setFieldValue(
                        'form.notification.weekly_all_items_at_risk',
                        !values.checked
                      );
                      toast.error(
                        'Error updating notifications, please try again'
                      );
                    }
                  },
                },
              },
              {
                precondition: () =>
                  contact?.form?.authorization === 'Executive',
                name: 'form.notification.weekly_all_stages_at_risk',
                itemType: 'checkbox',
                label: (
                  <span>
                    Weekly <u>All Stages at Risk</u> email notification.
                  </span>
                ),
                jItemProps: {
                  // loading: patchResult.isLoading,
                  onChange: async (values: any) => {
                    try {
                      values.setFieldValue(
                        'form.notification.weekly_all_stages_at_risk',
                        values.checked
                      );
                      await patchContact({
                        id: contact.id,
                        form: {
                          notification: {
                            weekly_all_stages_at_risk: values.checked,
                          },
                        },
                      } as Contact);
                    } catch (error) {
                      values.setFieldValue(
                        'form.notification.weekly_all_stages_at_risk',
                        !values.checked
                      );
                      toast.error(
                        'Error updating notifications, please try again'
                      );
                    }
                  },
                },
              },
            ]}
          />
        </Grid> */}
        <Grid item xs={12} sx={{ mt: 3 }}>
          <JFormik
            initialValues={(resource: any) =>
              ({ password: '', passwordConfirm: '' } as any)
            }
            validationSchema={Yup.object({
              password: Yup.string().required('Password is required'),
              passwordConfirm: Yup.string()
                .oneOf(
                  [Yup.ref('password'), null],
                  'Please make sure your passwords match'
                )
                .required('Confirm password is required'),
            })}
            handleSubmit={async (values, formik) => {
              try {
                const res = await changepw(values);
                if ('error' in res) {
                  toast.error('Unable to change password, please try again');
                } else {
                  toast.success('Password change successful');
                }
              } catch (error) {
                toast.error('Unable to change password, please try again');
              }
              formik.resetForm();
            }}
            form={[
              {
                name: 'h6',
                itemType: 'typography',
                label: 'Change Password',
                jItemProps: { variant: 'h6', align: 'center' },
              },
              {
                name: 'subtitle1',
                itemType: 'typography',
                label: `If you want to change your password please enter it below and click submit`,
                jItemProps: {
                  variant: 'subtitle1',
                  align: 'center',
                  color: 'textSecondary',
                },
              },
              {
                name: 'password',
                itemType: 'textfield',
                jItemProps: { type: 'password' },
                label: 'Password',
              },
              {
                name: 'passwordConfirm',
                itemType: 'textfield',
                jItemProps: { type: 'password' },
                label: 'Password Confirm',
              },
              {
                name: 'submit',
                itemType: 'button',
                jItemProps: { type: 'submit' },
                label: 'Submit',
              },
            ]}
          />
        </Grid>
      </Grid>
    );
  }
};
